module.exports = __webpack_public_path__ + "static/img/ms_mzjg_icon.png";